import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Phone } from "lucide-react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { ResponsiveImage } from "@/components/ResponsiveImage";

const Realisations = () => {
  const handleContactClick = () => {
    window.location.href = "tel:0658864706";
  };

  const handleDevisClick = () => {
    window.location.href = "/contact";
  };

  // Chantiers simplifiés
  const chantiers = [
    {
      title: "Chantier 1",
      images: [
        "./images/Chantier 1 salon .png",
        "./images/Chantier 1 salle a manger .png",
        "./images/Chantier 1 cuisine .png",
        "./images/Chantier 1 double fenetre .png",
        "./images/Chantier 1 douche .png",
        "./images/Chantier 1 Lavabo .jpeg",
        "./images/Chantier 1 Cafe .png"
      ]
    },
    {
      title: "Chantier 2",
      images: [
        "./images/zz1.jpeg",
        "./images/zz2.jpeg",
        "./images/zz3.jpeg",
        "./images/zz4.jpeg"
      ]
    },
    {
      title: "Chantier 3",
      images: [
        "./images/aa1.png",
        "./images/aa2.png",
        "./images/aa3.jpeg",
        "./images/aa4.jpeg"
      ]
    },
    {
      title: "Chantier 4",
      images: [
        "./images/tt 1 .jpeg",
        "./images/tt2.jpeg",
        "./images/tt3.jpeg",
        "./images/tt4.png",
        "./images/tt5 .png",
        "./images/tt6.jpeg"
      ]
    },
    {
      title: "Chantier 5",
      images: [
        "./images/ee1.jpeg",
        "./images/ee2.png",
        "./images/ee3.png",
        "./images/ee4.png"
      ]
    },
    {
      title: "Chantier 6",
      images: [
        "./images/salle de bain 2 .jpeg",
        "./images/salle de bain 3 .jpeg",
        "./images/salle de bain 4.jpeg",
        "./images/salle de bain 4 .png",
        "./images/salle de bain 5 .png",
        "./images/salle de bain 7.png"
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-primary via-primary-glow to-secondary py-20 lg:py-32">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-white">
            <Badge className="mb-4 bg-white/20 text-white border-white/30">
              Portfolio
            </Badge>
            <h1 className="text-4xl lg:text-6xl font-bold mb-6 leading-tight">
              Nos Réalisations
            </h1>
            <p className="text-xl mb-8 text-white/90 leading-relaxed max-w-3xl mx-auto">
              Découvrez nos derniers projets de peinture et décoration. 
              Chaque chantier reflète notre savoir-faire et notre attention aux détails.
            </p>
          </div>
        </div>
      </section>

      {/* Chantiers Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16">
            {chantiers.map((chantier, chantierIndex) => (
              <div key={chantierIndex} className="space-y-8">
                {/* Titre du chantier */}
                <div className="text-center">
                  <h2 className="text-3xl lg:text-4xl font-bold">{chantier.title}</h2>
                </div>

                {/* Galerie d'images */}
                <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-6">
                  {chantier.images.map((imageSrc, imageIndex) => (
                    <Card key={imageIndex} className="overflow-hidden hover:shadow-lg transition-shadow">
                      <ResponsiveImage 
                        src={imageSrc} 
                        alt={`${chantier.title} - Photo ${imageIndex + 1}`}
                        className="w-full h-48 md:h-64 object-cover hover:scale-105 transition-transform duration-300"
                      />
                    </Card>
                  ))}
                </div>

                {/* Séparateur entre chantiers */}
                {chantierIndex < chantiers.length - 1 && (
                  <div className="border-t border-muted pt-8"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary text-primary-foreground">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl lg:text-4xl font-bold mb-6">Votre projet nous intéresse !</h2>
          <p className="text-xl mb-8 opacity-90">
            Vous avez un projet de peinture ou décoration ? Contactez-nous pour un devis gratuit 
            et découvrez comment nous pouvons transformer votre espace.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={handleContactClick}
              size="lg"
              className="bg-secondary hover:bg-secondary/90 text-white px-8 py-4"
            >
              <Phone className="h-5 w-5 mr-2" />
              06 58 86 47 06
            </Button>
            <Button 
              onClick={handleDevisClick}
              variant="outline" 
              size="lg"
              className="border-white text-white hover:bg-white hover:text-primary px-8 py-4"
            >
              Demander un devis
            </Button>
          </div>
          <div className="mt-8">
            <Button 
              asChild
              variant="link" 
              className="text-white hover:text-secondary"
            >
              <Link to="/">
                Retour à l'accueil
              </Link>
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Realisations;